// 电桩详情--订单信息
import React, { Component } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import "@ant-design/compatible/assets/index.css";
import { getChargeOrderDetail, prefixFile } from "@/fetch/fetchApi";
import PropTypes from "prop-types";
import FormCore from "@/components/display/form/formCore";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class ChargeOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.chargeOrderDetail;

    this.queryParam = null;
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.queryParam = window.LayoutTab.tabParam.params ? window.LayoutTab.tabParam.params : "";
    }

    this.state = {
      data: this.queryParam,
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    // 初始定义表格数据

    this.initGrid();
  }

  initGrid() {
    console.log(this.state.data);
    this.formConfig = {
      childItems: [
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              text: this.internationalization.btn1, // '导出',
              icon: "export",
              handler: (e, param) => {
                this.exportData(param);
              },
            },
          ],
        },
      ], // 设置表单元素
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        cityId: this.state.data.detailCityId,
        type: this.state.data.detailType,
        startTime: this.state.data.currentDate[0].format("YYYYMMDD"),
        endTime: this.state.data.currentDate[1].format("YYYYMMDD"),
        operationMode: this.state.data.operationMode,
        operationProperty: this.state.data.operationProperty,
        isSuccess: this.state.data.isSuccess,
        stubVersionType: this.state.data.detailStubVersionType,
        endCode: this.state.data.detailEndCode,
        appkey: this.state.data.detailAppkey,
      },
      autoLoadGrid: !0, // 设置为false不触发加载grid
      context: this,
      tableKey: "orderInfoTable",
    };
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: this.internationalization.title1, // '订单编号',
            key: "orderId",
            align: "center",
          },
          {
            name: this.internationalization.title2, // ''设备编号',
            key: "stubId",
            align: "center",
            colType: "textCol",
          },
          {
            name: this.internationalization.title3, // ''充电时间',
            key: "chargeTime",
            align: "center",
          },
          {
            name: this.internationalization.title4, // ''用户编号',
            key: "userId",
            align: "center",
          },
          {
            name: this.internationalization.title5, // ''电量',
            key: "power",
            align: "center",
          },
          {
            name: this.internationalization.title6, // ''车辆VIN',
            key: "vin",
            align: "center",
          },
          {
            name: "车型",
            key: "carTypeNo",
            align: "center",
          },
          {
            name: this.internationalization.title8, // ''充电渠道',
            key: "appkeyName",
            align: "center",
          },
          {
            name: this.internationalization.title9, // ' '停止原因',
            key: "endCodeName",
            align: "center",
          },
          {
            name: this.internationalization.action, // ''操作',
            key: "action",
            fix: "right",
            width: 100,
            colType: "action",
            actionMap: [
              {
                type: "href",
                actionName: "充电数据",
                handler: (res) => {
                  if (this.props.cancelModal) {
                    this.props.cancelModal();
                  }
                  this.sleeps(500).then(() => {
                    this.openTab(
                      {
                        keyId: "chargeCourse",
                        orderId: res.orderId,
                      },
                      {
                        key: "chargeCourse",
                        titleText: "充电数据",
                      },
                    );
                  });
                },
              },
              {
                type: "href",
                actionName: "模块数据",
                handler: (res) => {
                  if (this.props.cancelModal) {
                    this.props.cancelModal();
                  }
                  this.sleeps(500).then(() => {
                    this.openTab(
                      {
                        keyId: "powerCourse",
                        orderId: res.orderId,
                      },
                      {
                        key: "powerCourse",
                        titleText: "模块数据",
                      },
                    );
                  });
                },
              },
            ],
          },
        ],
        tableParam: {
          pageCount: 10,
        },
        tableInfo: {
          hasRow: !1, // 是否显示checkbox
        },
        tableChange: () => {
          // grid翻页页，排序， 筛选过滤时触发
          console.debug("change");
        },
        autoRefresh: !1, // 设置为true 直接加载grid数据
        dataApi: getChargeOrderDetail,
        tableKey: "orderInfoTable",
      },
    });
  }

  sleeps(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  openTab = (param, e) => {
    this.props.onAdd(e, param);
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  // 数据导出
  exportData(param) {
    const excelUrl = `${prefixFile}/exportOrderSummaryDetail.do`;
    const params = `cityId=${
      param.cityId
    }&startTime=${
      param.startTime
    }&endTime=${
      param.endTime
    }&type=${
      param.type
    }&operationMode=${
      param.operationMode
    }&operationProperty${
      param.operationProperty
    }&isSuccess=${
      param.isSuccess
    }&stubVersionType=${
      param.stubVersionType
    }&endCode=${
      param.endCode
    }&appkey=${
      param.appkey}`;
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  }

  render() {
    const Content = (
      <div>
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} />
        </div>
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );
    return Content;
  }
}

export default injectIntl(ChargeOrderDetail);
ChargeOrderDetail.propTypes = {
  // layout: PropTypes.string,
  // modalSubmit: PropTypes.func,
  // tableKey: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/chargeOrderDetail.js